import React, { Component, Fragment } from 'react';
import { TextArea, Icon, Popup } from 'semantic-ui-react'

class CustomUpdateRenderer extends Component {
  constructor(props){
    super(props)

    this.state = {
      value: this.props.value,
      editing: false,
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if(!(this.state.editing || this.props.onUpdatePending)) {
      this.setState({
        value: nextProps.value,
      })
    }
  }

  onChangeValue = (value) => {
    this.setState({
      value: value,
    })
  }

  onEditClick = (e) => {
    e.stopPropagation()

    if(this.props.onEditClick !== undefined) {
      this.props.onEditClick()
    }

    this.setState({
      editing: true,
    })
  }

  onSaveClick = (e) => {
    e.stopPropagation()

    if(this.props.onSaveClick !== undefined) {
      this.props.onSaveClick(this.state.value, this.props.value, this.props.risk)
    }

    this.setState({
      editing: false,
    })
  }

  onDeleteClick = (e) => {
    e.stopPropagation()

    if(this.props.onDeleteClick !== undefined) {
      this.props.onDeleteClick(this.props.value, this.props.risk)
    }

    this.setState({
      editing: false,
    })
  }

  onCancelClick = (e) => {
    e.stopPropagation()

    if(this.props.onCancelClick !== undefined) {
      this.props.onCancelClick()
    }

    this.setState({
      editing: false,
    })
  }

  render() {
    const { save, cancel, edit } = this.props.translations
    const delete_label = this.props.translations.delete
    return (
      <div className="custom-update-renderer">
        {
          (this.state.editing || this.props.onUpdatePending)?
          <Fragment>
            <TextArea rows={2} defaultValue={ this.props.value } className="custom-update-renderer-textarea" onChange={ (traget, { value }) => this.onChangeValue(value) } disabled={ this.props.onUpdatePending } onClick={ (e) => e.stopPropagation() }/>
            {
              !this.props.onUpdatePending &&
              <span className="custom-update-renderer-buttons">
                <div>
                  <Popup
                    trigger={ <Icon link name="save" onClick={ (e) => this.onSaveClick(e) }/> }
                    content={ save }
                  />
                </div>
                <div>
                  <Popup
                    trigger={ <Icon link name="cancel" onClick={ (e) => this.onCancelClick(e) }/> }
                    content={ cancel }
                  />
                </div>
              </span>
            }
            {
              this.props.onUpdatePending &&
              <span className="custom-update-renderer-buttons">
                <div><Icon name="circle notch" loading/></div>
              </span>
            }
          </Fragment>
          : (
              <Fragment>
                <span>{ this.props.value }</span>
                {
                  !this.props.onDeletePending &&
                  <span className="custom-update-renderer-buttons">
                    <div>
                      <Popup
                        trigger={ <Icon link name="edit" onClick={ (e) => this.onEditClick(e) }/> }
                        content={ edit }
                      />
                    </div>
                    <div>
                      <Popup
                        trigger={ <Icon link name="trash alternate" onClick={ (e) => this.onDeleteClick(e) }/> }
                        content={ delete_label }
                      />
                    </div>
                  </span>
                }
                {
                  this.props.onDeletePending &&
                  <span className="custom-update-renderer-buttons">
                    <div><Icon name="circle notch" loading/></div>
                  </span>
                }
              </Fragment>
            )
        }
      </div>
    )
  }
}

export default CustomUpdateRenderer



// WEBPACK FOOTER //
// ./src/components/custom_update_renderer.js